<template>
  <div class="talentIntroduction">
    <!-- <Header /> -->
    <!-- banner -->
    <van-image class="jpgimg"
      :src="require('../../../assets/images/rencaiyinliu/rencai-02.png')"
    />
    <!-- 常见问题 -->
    <div class="rencaiTop">
      <p>人才引进落户上海<span>常见问题</span></p>
      <div class="hrdiv"></div>
    </div>
    <ul class="commonProblemUl">
      <li v-for="(item, index) in box1textList" :key="index">
        <van-image :src="item.image" />
        <div class="commonProblemText">
          <div class="brireDiv"></div>
          <p>{{ item.text }}</p>
        </div>
      </li>
    </ul>
    <!-- 资讯服务 -->
    <div class="rencaiTop">
      <p>百才汇专业人才引进落户<span>咨询服务</span>有哪些？</p>
      <div class="hrdiv"></div>
    </div>
    <ul class="zixunfuwuUl">
      <li v-for="(item, index) in InformationServices" :key="index">
        <van-image :src="item.img" />
      </li>
    </ul>
    <!-- 服务流程 -->
    <div class="rencaiTop">
      <p>百才汇专业人才引进落户<span>咨询服务</span>有哪些？</p>
      <div class="hrdiv"></div>
    </div>
    <ul class="ServiceProcess">
      <li v-for="(item, index) in ServiceProcesslist" :key="index">
        <div class="vanImage">
          <van-image :src="item.icon" />
          <p>{{ item.title }}</p>
        </div>
        <div class="pDiv">
          <div class="yuanDiv"></div>
          <p class="p1"><span></span>{{ item.text1 }}</p>
        </div>
        <div class="pDiv">
          <div class="yuanDiv"></div>
          <p class="p2"><span></span>{{ item.text2 }}</p>
        </div>
        <div class="pDiv" v-if="item.text3">
          <div class="yuanDiv"></div>
          <p class="p3"><span></span>{{ item.text3 }}</p>
        </div>
      </li>
    </ul>
    <!-- 联系我们 -->
    <div class="fomboxbks">
      <van-image
        :src="require('../../../assets/images/rencaiyinliu/formImg.png')"
      />
      <div class="title">
        <p class="p2">百才汇—你的私人落户专家</p>
        <div class="hrdiv"></div>
        <p class="p1">
          集团总部坐落于上海人才大厦22楼，人才大厦是上海人力资源产业的地标性建筑，也是办理上海落户的政府大楼，百才汇坐拥强势资源，致力于帮助每一位想在上海落户的人才，实现他们的上海梦乃至人生梦。
        </p>
      </div>
      <div class="fombox">
        <div class="inputis">
          <p>你的姓名</p>
          <input
            class="inpis"
            v-model="formLabelAlign.name"
            type="text"
            placeholder="请输入你的姓名 "
          />
          <p>联系电话</p>
          <input
            class="inpis"
            v-model="formLabelAlign.phone"
            type="text"
            placeholder="请输入你的联系电话"
          />
          <button class="btnis"  @click="sbmitForm">提交</button>
        </div>
        <!-- <p class="titeljieshao">联系我们</p> -->
        <!-- <el-form label-width="750px" :model="formLabelAlign">
          <el-form-item label="你的姓名">
            <img class="img1" src="../../../assets/images/red.png" alt="" />
            <el-input
              v-model="formLabelAlign.name"
              placeholder="你的姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="phone">
            <img class="img1" src="../../../assets/images/red.png" alt="" />
            <el-input
              v-model="formLabelAlign.phone"
              placeholder="请输入你的联系方式"
            ></el-input>
          </el-form-item>
        </el-form> -->
        <!-- <div class="button">提交</div> -->
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Header from "../../../components/Header";
import Foot from "../../../components/Foot";
import Vue from "vue";
import { Notify } from "vant";
export default {
  components: { Header, Foot },
  head() {
    return {
      title: "人才引进落户_人才引进政策-百才汇",
      meta: [
        {
          name: "keywords",
          content: "人才引进落户,人才引进落户政策",
        },
        {
          name: "description",
          content:
            "人才引进落户就找百才汇，1对1咨询定制人才引进落户方案，专业靠谱的落户团队，拥有大量的成功案例，并为您解读人才引进落户,人才引进落户政策新政策等信息！",
        },
      ],
    };
  },
  data() {
    return {
      //form表单
      formLabelAlign: {
        name: "",
        phone: "",
      },
      navigationData: [
        // {
        //   title: "人才引进政策适用对象有哪些人群？",
        // },
        // {
        //   title:
        //     "得了市教委颁发的优秀毕业生证书，可以通过省部级奖励这条办理人才引进吗？",
        // },
        // {
        //   className: "“人才引进政策”中的金融重点机构有哪些？",
        // },
        // {
        //   title: "什么是“省部级奖励”？",
        // },
        // {
        //   title:
        //     "工作经历是劳务派遣/人事代理/外包的，社保和个税由上海外服代交，有什么影响吗？",
        // },
        // {
        //   title: "需要提供居住证吗？没有办理居住证或居住证积分中断过有影响吗？",
        // },
      ],
      box1textList: [
        {
          text: "人才引进政策适用对象有哪些人群？",
          image: require("../../../assets/images/rencaiyinliu/icon01.png"),
        },
        {
          text:
            "得了市教委颁发的优秀毕业生证书，可以通过省部级奖励这条办理人才引进吗？",
          image: require("../../../assets/images/rencaiyinliu/icon02.png"),
        },
        {
          text: "“人才引进政策”中的金融重点机构有哪些？",
          image: require("../../../assets/images/rencaiyinliu/icon03.png"),
        },
        {
          text: "什么是“省部级奖励”？",
          image: require("../../../assets/images/rencaiyinliu/icon04.png"),
        },
        {
          text:
            "工作经历是劳务派遣/人事代理/外包的，社保和个税由上海外服代交，有什么影响吗？",
          image: require("../../../assets/images/rencaiyinliu/icon05.png"),
        },
        {
          text: "需要提供居住证吗？没有办理居住证或居住证积分中断过有影响吗？",
          image: require("../../../assets/images/rencaiyinliu/icon06.png"),
        },
      ],
      username: "",
      tel: "",
      liuyan: "",
      // 资讯服务
      InformationServices: [
        {
          img: require("../../../assets/images/rencaiyinliu/icon1.png"),
        },
        {
          img: require("../../../assets/images/rencaiyinliu/icon2.png"),
        },
        {
          img: require("../../../assets/images/rencaiyinliu/icon3.png"),
        },
        {
          img: require("../../../assets/images/rencaiyinliu/icon4.png"),
        },
        {
          img: require("../../../assets/images/rencaiyinliu/icon5.png"),
        },
        {
          img: require("../../../assets/images/rencaiyinliu/icon6.png"),
        },
      ],
      ServiceProcesslist: [
        {
          icon: require("../../../assets/images/rencaiyinliu/icon11.png"),
          title: "前期在线沟通",
          text1: "客户填写基础信息（关注公证号领取免费咨询券）",
          text2: "落户专家给予初步反馈",
          text3: "",
        },
        {
          icon: require("../../../assets/images/rencaiyinliu/icon12.png"),
          title: "办公室面签",
          text1: "线下面谈沟通",
          text2: "规划落户流程、时间节点、注意事项等",
          text3: "现场合同讲解、签约",
        },
        {
          icon: require("../../../assets/images/rencaiyinliu/icon13.png"),
          title: "签约后初期",
          text1: "客户背景情况调整、如有瑕疵点进行补足",
          text2: "完成递交所需的材料",
          text3: "",
        },
        {
          icon: require("../../../assets/images/rencaiyinliu/icon14.png"),
          title: "签约后中期",
          text1: "区人才服务中心递交材料",
          text2: "区级、市级审批、落户公示",
          text3: "",
        },
        {
          icon: require("../../../assets/images/rencaiyinliu/icon15.png"),
          title: "签约后后期",
          text1: "拿到落户通知书、公安局准迁证",
          text2: "到原户籍地开迁移证、调档",
          text3: "派出所落户",
        },
      ],
    };
  },
  mounted() {
    // var mySwiper = new Swiper(".swiper-container1", {
    //   slidesPerView: 3,
    //   spaceBetween: 20,
    //   direction: "horizontal",
    //   loop: false,
    //   prevButton: ".swiper-button-prev",
    //   nextButton: ".swiper-button-next",
    // });
  },
  methods: {
    //form表单提交
    sbmitForm() {
      let _form = this.formLabelAlign;
      if (!_form.name) {
        Notify({ type: "warning", message: "请输入姓名！" });
        return false;
      }
      if (!this.formLabelAlign.phone) {
        Notify({ type: "warning", message: "请输入正确手机号码" });
        return false;
      }
      this.$axios
        .post("/trip/InfoSources/WebRegister", {
          C01_Name: _form.name, //姓名
          C01_Tel: _form.phone, //联系方式
          C01_Origin: 193, //来源于那个官网
        })
        .then((res) => {
          if (res.data.Code == 200) {
            Notify({ type: "success", message: "提交成功！" });
            this.formLabelAlign.name = "";
            this.formLabelAlign.phone = "";
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.talentIntroduction {
  margin-top: 80px;
  .jpgimg{
    height: 400px;
  }
  .rencaiTop {
    width: 100%;
    display: flex;
    // justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-top: 60px;
    margin-bottom: 20px;
    p {
      height: 30px;
      font-size: 30px;
      font-weight: bold;
      color: #333333;
      letter-spacing: 1px;
      line-height: 28px;
      span {
        color: #dcb37a;
      }
    }
    .hrdiv {
      margin-top: 10px;
      width: 80px;
      height: 3px;
      background: #aa8756;
    }
  }
  //常见问题
  .commonProblemUl {
    margin: 0px 40px;
    li {
      position: relative;
      margin-top: 20px;
      display: flex;
      align-items: center;
      .commonProblemText {
        position: absolute;
        display: flex;
        top: 0px;
        height: 100%;
        align-items: center;
        right: 30px;

        p {
          width: 438px;
          margin-left: 20px;
        }
        .brireDiv {
          width: 10px;
          height: 10px;
          background: #dcb37a;
          border-radius: 50%;
        }
      }
    }
  }
  //资讯服务
  .zixunfuwuUl {
    margin: 0px 40px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    li {
      width: 320px;
      height: 200px;
      margin-top: 20px;
    }
  }
  .ServiceProcess {
    margin: 0px 40px;
    li {
      padding-top: 20px;
      .vanImage {
        position: relative;
        display: flex;
        align-items: center;
        p {
          position: absolute;
          left: 90px;
          font-size: 22px;
          font-weight: bold;
          color: #ffffff;
        }
      }
      .pDiv {
        display: flex;
        align-items: center;
        .yuanDiv {
          margin-left: 50px;
          width: 6px;
          height: 6px;
          background: #333333;
          border-radius: 50%;
          margin-top: 10px;
        }
        .p1,
        .p2,
        .p3 {
          margin-left: 20px;
          font-size: 22px;
          font-weight: 400;
          color: #666666;
          margin-top: 10px;
          // span {
          //   width: 6px;
          //   height: 6px;
          //   background: #333333;
          //   border-radius: 50%;
          // }
        }
      }
    }
  }
  .fomboxbks {
    position: relative;
    z-index: 1;
    padding-top: 60px;
    display: flex;
    justify-content: center;
    margin-bottom: 360px;
    .title {
      position: absolute;
      .p2 {
        margin-top: 40px;
        text-align: center;
        font-size: 30px;
        font-weight: bold;
        color: #ffffff;
      }
      .hrdiv {
        margin: 0px auto;
        margin-top: 10px;
        width: 80px;
        height: 3px;
        background: #ffffff;
      }
      .p1 {
        margin: 0px 40px;
        letter-spacing: 1px;
        margin-top: 40px;
        font-size: 22px;
        font-weight: 400;
        color: #ffffff;
        line-height: 34px;
      }
    }
    .fombox {
      position: absolute;
      bottom: -290px;
      z-index: 2;
      width: 693px;
      border-radius: 10px;
      background: #ffffff;
      box-shadow: 0px 5px 10px 0px rgba(170, 135, 86, 0.2);
      // background: url("../../../assets/images/baicaihuiliuxueshengluohu/formbkbox.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;
      padding-top: 40px;
      padding-bottom: 40px;
      .inputis {
        width: 420px;
        margin: auto;
        p {
          font-size: 22px;
          font-weight: 400;
          color: #333333;
          margin-bottom: 10px;
        }
        .inpis {
          background: url("../../../assets/images/red.png") no-repeat 12px;
          background-size: 3% 20%;
          width: 420px;
          height: 50px;
          border: 1px solid #dcb37a;
          border-radius: 10px;
          padding-left: 30px;
          box-sizing: border-box;
          margin-bottom: 17px;
        }
        button:focus {
          outline: 0;
        }
        .btnis {
          width: 140px;
          background: #dcb37a;
          height: 40px;
          border-radius: 20px;
          font-size: 24px;
          font-weight: bold;
          color: #ffffff;
          display: block;
          margin: auto;
        }
      }
      .titeljieshao {
        font-size: 30px;
        font-weight: bold;
        color: #b58645;
        text-align: center;
        letter-spacing: 1px;
      }
      /deep/.el-form {
        text-align: center;
        margin-top: 10px;
        .el-form-item {
          margin-bottom: 40px;
          .el-form-item__label {
            text-align: left;
            font-size: 14px;
            color: #606266;
            line-height: 0px;
            padding-left: 92px;
          }
          .el-input__suffix {
            top: 6px;
          }
          .el-form-item__error {
            left: 1.3rem;
          }
          .el-input {
            width: 520px;
            height: 50px;
          }
          .el-form-item__content {
            margin-top: 0.25rem;
            line-height: inherit;
            margin-left: 0 !important;
            .el-input__inner {
              padding-left: 30px;
              font-size: 14px;
              width: 520px;
              height: 50px;
              background: #ffffff;
              border: 2px solid #aa8756;
              border-radius: 5px;
            }
          }
        }
        .img1 {
          position: absolute;
          z-index: 2;
          top: 15px;
          margin-left: 15px;
          width: 10px;
        }
      }
      .button {
        width: 200px;
        height: 50px;
        background: #e3af66;
        border-radius: 25px;
        text-align: center;
        margin: 0 auto;
        cursor: pointer;
        letter-spacing: 1px;
        font-size: 24px;
        font-weight: bold;
        color: #ffffff;
        line-height: 50px;
      }
    }
    //
  }
}
</style>
